module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-3.webp?7c6a84d6";